import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { media } from 'gipsy-ui'
import variables from 'assets/styles/variables'

import { styles, translations, utils } from 'gipsy-misc'
import { AnimateHeight, LargeButton } from 'gipsy-ui'

import container from './container'
import EmptyContent from 'pages/teamlist/teamPage/emptyContent'
import ListHeader from 'features/list/components/listHeader'
import InviteUserInput from 'features/teamlist/components/inviteUserInput'
import InlineAddTask from 'features/list/components/inlineAddTask'
import TaskPanel from 'features/taskPanel'
import { headerPaddingStyle } from 'features/list/styles'
import {
  onMouseEnter,
  onMouseLeave,
  onDragStart as onDragStartGeneric,
  onDragEnd,
  onDrop as onDropGeneric,
  onDropComplete
} from 'features/draganddrop/utils'

import DraggableList from 'features/list/components/draggableList'

class InviteUserComponent extends PureComponent {
  state = {
    hide: false
  }

  onAddUsers = users => {
    if (users.length === 0) {
      return
    }
    this.setState({ hide: true })
    try {
      this.props.onAddUsers(users)
    } catch (err) {
      this.setState({ hide: false })
    }
  }

  render() {
    return (
      <EmptyContent
        title={translations.teamlist.inviteUser.emptyState.title}
        subtitle={translations.teamlist.inviteUser.message}
        hide={this.state.hide}>
        <InviteUserInputWrapper className="invite-user-input-wrapper">
          <InviteUserInput onAddUsers={this.onAddUsers} />
        </InviteUserInputWrapper>
      </EmptyContent>
    )
  }
}

const InviteUserInputWrapper = styled.div`
  width: 100%;
`

class TeamlistPage extends PureComponent {
  static propTypes = {
    teamItems: PropTypes.object,
    actions: PropTypes.object.isRequired,
    onComplete: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    highlightIds: PropTypes.array,
    groups: PropTypes.array.isRequired,
    onMarkAllAsRead: PropTypes.func.isRequired,
    onAddUsers: PropTypes.func.isRequired,
    hasNoMember: PropTypes.bool.isRequired,
    itemsLoaded: PropTypes.bool.isRequired
  }

  constructor(props) {
    super(props)

    this.state = {
      dragging: false,
      draggedHeight: 0
    }

    this.onMouseEnter = onMouseEnter.bind(this)
    this.onMouseLeave = onMouseLeave.bind(this)
    this.onDragEnd = onDragEnd.bind(this)
    this.onDragStartGeneric = onDragStartGeneric.bind(this)
    this.onDropGeneric = onDropGeneric.bind(this)
    this.onDropComplete = onDropComplete.bind(this)
  }

  onDragStart = data => {
    this.onDragStartGeneric(data, this.props.actions.cancelGetTeamlist)
  }

  onDrop = result => {
    this.onDropGeneric(result, this.props.actions.dragAndDrop)
  }

  renderTeamList = () => {
    const { teamItems, onClick, onComplete, onChange, highlightIds, groups, onMarkAllAsRead } = this.props

    const { dragging } = this.state

    return (
      <React.Fragment>
        <CreateButtonContainer>
          <AddButton
            rightIconName="Plus"
            onClick={() => this.props.actions.openPanel()}
            iconBackground={'linear-gradient(180deg, #643fdb 0%, #744aff 100%)'}>
            {translations.teamlist.buttons.addTask}
          </AddButton>
          <AddButton
            rightIconName="Star"
            onClick={() => this.props.actions.openRequestReviewPanel()}
            iconBackground={'linear-gradient(180deg, #643fdb 0%, #744aff 100%)'}>
            {translations.teamlist.buttons.requestReview}
          </AddButton>
        </CreateButtonContainer>
        {groups.map((group, index) => {
          const list = teamItems[group].list
          const height = list && list.length > 0 ? 'auto' : 0
          return (
            <AnimateHeight key={group} duration={300} height={height}>
              <Group key={group} className="group" empty={!list || !list.length}>
                {group === 'updates' ? (
                  <ListHeader
                    group={group}
                    onClick={onMarkAllAsRead}
                    rightText={translations.list.markAllUpdateAsRead}
                  />
                ) : (
                  <ListHeader group={group} />
                )}
                {
                  <DraggableList
                    dragging={dragging}
                    onDragStart={this.onDragStart}
                    onDragEnd={this.onDragEnd}
                    onMouseEnter={this.onMouseEnter}
                    onMouseLeave={this.onMouseLeave}
                    onDrop={this.onDrop}
                    group={group}
                    list={list}
                    highlightIds={highlightIds}
                    onClick={onClick}
                    onComplete={onComplete}
                    onChange={onChange}
                  />
                }
                {!utils.datetime.isGroupUpcoming(group) &&
                  !utils.datetime.isGroupOnboarding(group) &&
                  !utils.datetime.isGroupUpdates(group) && (
                    <InlineAddTask
                      group={group}
                      assignee={this.props.activeTeamMember}
                      withTags={false}
                      withAssignee={false}
                    />
                  )}
              </Group>
            </AnimateHeight>
          )
        })}
      </React.Fragment>
    )
  }

  render() {
    const { activeTeamMember, teamItems, hasNoMember, hasNoTask, itemsLoaded } = this.props

    return (
      <Page id="team-page">
        {hasNoMember && <InviteUserComponent onAddUsers={this.props.onAddUsers} />}
        {!hasNoMember && itemsLoaded && hasNoTask && (
          <EmptyContent
            title={translations.teamlist.emptyState.title.replace(
              '[user]',
              utils.user.getDisplayName(activeTeamMember)
            )}
            style={{ maxWidth: 375 }}>
            <React.Fragment>
              <StyledButton rightIconName="Plus" onClick={this.props.actions.openPanel}>
                {`${translations.teamlist.buttons.addTask} for ${utils.user.getDisplayName(activeTeamMember)}`}
              </StyledButton>
              <StyledButton rightIconName="Star" onClick={this.props.actions.openRequestReviewPanel}>
                {`${translations.teamlist.buttons.requestReview} from ${utils.user.getDisplayName(activeTeamMember)}`}
              </StyledButton>
            </React.Fragment>
          </EmptyContent>
        )}
        {!hasNoMember && itemsLoaded && !hasNoTask && teamItems && this.renderTeamList()}
        <TaskPanel />
      </Page>
    )
  }
}

const Page = styled.div`
  min-width: 320px;
  padding-left: ${parseInt(variables.sidebarWidth, 10) + 8}px;
  ${media['tablet-wide']`
    padding-right: 0px;
  `}
  ${media['phone-wide']`
    padding-left: 0px;
    padding-top: ${variables.mobileTeamMembersHeight};
  `}
`

const StyledButton = styled(LargeButton)`
  min-width: 275px !important;
  margin-bottom: 20px;
`

const Group = styled.div`
  position: relative;
  margin-bottom: 50px;
  padding-bottom: 0;
  ${({ empty }) =>
    empty &&
    css`
      display: none;
    `}
`

const CreateButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
  ${headerPaddingStyle}
  ${media['phone-wide']`
   justify-content:center;
`}
`

const AddButton = styled(LargeButton)`
  background-color: ${styles.colors.lightVioletColor};
  width: 200px;
  color: ${styles.colors.primaryDarkColor};
  font-size: ${styles.fonts.fontSizeXSmall};
  margin-right: 20px;
  span {
    margin-left: -40px;
  }
  &:hover {
    background: ${styles.colors.backgroundPrimaryColor};
    color: white;
  }
`

export default container(TeamlistPage)



// WEBPACK FOOTER //
// ./src/pages/teamlist/teamPage/index.js